module.exports = __webpack_public_path__ + "assets/img/vintage.779422b5.svg";